import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { IconDefinitionConstants, SettingsConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { DimensionTypeInfoFormFieldProps } from "models/propTypes/settingsPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ActionLinkButton, Icon } from "components/common";
import { useSupportTicketCreateDialog } from "components/support";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import { DisplayType } from "models/enums/style";

const DimensionTypeInfoFormField: React.FC<DimensionTypeInfoFormFieldProps> = (props) => {
  const { dimensionType } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const { getDialog: getSupportTicketCreateDialog } = useSupportTicketCreateDialog();

  const onCreateSupportCaseClick = () => {
    dispatch(displayDialog(getSupportTicketCreateDialog()));
  };

  const getActiveDimensionCategories = (dimensionType: WintSuperkollAPIModel.DimensionSettingItem) => {
    const activeCategories = Object.entries(dimensionType)
      .filter(
        ([t, val]) =>
          (t === SettingsConstants.IsCustomerInvoiceActive ||
            t === SettingsConstants.IsReceiptActive ||
            t === SettingsConstants.IsSupplierInvoiceActive) &&
          val === true
      )
      .map(([t, val]) =>
        LocalizationHelperInstance.getFormattedMessage(
          t === SettingsConstants.IsCustomerInvoiceActive
            ? TranslationKeys.Invoice.CustomerInvoices
            : t === SettingsConstants.IsReceiptActive
            ? TranslationKeys.Common.Receipts
            : TranslationKeys.IncomingInvoice.IncomingInvoices
        )
      );
    let categories: string | undefined = undefined;
    const localizeAndString = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.And);
    if (activeCategories.length === 1) {
      categories = activeCategories[0];
    } else if (activeCategories.length === 2) {
      categories = `${activeCategories[0]} ${localizeAndString} ${activeCategories[1]}`;
    } else if (activeCategories.length === 3) {
      categories = `${activeCategories[0]}, ${activeCategories[1]} ${localizeAndString} ${activeCategories[2]}`;
    }
    return categories
      ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.ActiveDimensionCategories, "", {
          categories: categories,
          dimensionTypeName: dimensionType.dimensionTypeName ?? "",
        })
      : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.NothingActivated, "", {
          dimensionTypeName: dimensionType.dimensionTypeName ?? "",
        });
  };

  return (
    <Grid container className={cssExports.formControlDescription} direction={"column"}>
      {getActiveDimensionCategories(dimensionType)}

      <Grid item>
        <ActionLinkButton
          onClick={onCreateSupportCaseClick}
          endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} displayType={DisplayType.Info} />}
        >
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.CreateNewSupportCase)}
        </ActionLinkButton>
      </Grid>
    </Grid>
  );
};

export default DimensionTypeInfoFormField;
